<template>
  <div>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="date"
      lazy
      dark
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="date"
          label="Picker in menu"
          prepend-icon="Desde"
          readonly
          v-on="on"
        />
      </template>
      <v-date-picker
        v-model="date"
        no-title
        scrollable>
        <v-spacer/>
        <v-btn
          flat
          color="primary"
          @click="menu = false">Cancel</v-btn>
        <v-btn
          flat
          color="primary"
          @click="$refs.menu.save(date)">OK</v-btn>
      </v-date-picker>
    </v-menu>
    <v-menu
      ref="menu2"
      v-model="menu2"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="date2"
      lazy
      dark
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="date2"
          label="Picker in menu"
          prepend-icon="Hasta"
          readonly
          v-on="on"
        />
      </template>
      <v-date-picker
        v-model="date2"
        no-title
        scrollable>
        <v-spacer/>
        <v-btn
          flat
          color="primary"
          @click="menu2 = false">Cancel</v-btn>
        <v-btn
          flat
          color="primary"
          @click="$refs.menu2.save(date2)">OK</v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  data: () => ({
    date: new Date().toISOString().substr(0, 10),
    date2: new Date().toISOString().substr(0, 10),
    menu: false,
    menu2: false,
    modal: false,
    modal2: false
  })
}
</script>

<style>

  .v-menu{
    margin-left: 5% !important;
  }

  .v-input__prepend-outer {
     margin-right: 5% !important;
  }

  .v-picker.v-card {
    color: black !important;
  }

</style>
